import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import enviro from 'enviro';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useRecaptchav3 } from 'developer-experience-shared-components/recaptcha/hooks/useRecaptchaV3';
import { authorize } from '../actions/AppActions';
import { V3_SITE_KEYS } from '../constants/Recaptcha';
import { getAuthorizeStatus, getIsRequestingNewScopes } from '../selectors/AppSelectors';
import { getAuthorizationRequestInfo } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectAppButton = ({
  hasNoInstallPermission,
  hasUnconfirmedTerms
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const authorizeStatus = useSelector(getAuthorizeStatus);
  const isRequestingNewScopes = useSelector(getIsRequestingNewScopes);
  const recaptchaKey = V3_SITE_KEYS[enviro.getShort()];
  const {
    executeRecaptcha
  } = useRecaptchav3({
    reCaptchaKey: recaptchaKey
  });
  const authorizeApp = data => {
    dispatch(authorize({
      data,
      trackerOptions: {
        hasInstallPermission: !hasNoInstallPermission,
        isRequestingNewScopes: !!isRequestingNewScopes
      }
    })).unwrap().catch(e => {
      Raven.captureException(e);
    });
  };
  const onConnectAppClicked = () => {
    executeRecaptcha().then(token => authorizeApp(getAuthorizationRequestInfo(location.search, token))).catch(e => Raven.captureException(e));
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: hasNoInstallPermission ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "oauth.app.marketplaceAccess.needPermissionTooltip"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "oauth.app.termsAndPrivacy.tooltip"
    }),
    disabled: !hasNoInstallPermission && !hasUnconfirmedTerms,
    children: /*#__PURE__*/_jsx(UILoadingButton, {
      use: "primary",
      loading: authorizeStatus.pending,
      onClick: onConnectAppClicked,
      "data-test-id": "authorize-button",
      keepResultAfterFinish: true,
      disabled: hasNoInstallPermission || !executeRecaptcha || hasUnconfirmedTerms,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.authorization.connectApp"
      })
    })
  });
};
export default ConnectAppButton;